// @ts-nocheck
import { forwardRef } from "react";
import { Image, Modal } from "antd";
import { Fragment, h } from "preact";
import { useEffect, useImperativeHandle, useState } from "preact/hooks";
import machineVersionGuide from "../../../../assets/picture/img_v3_0211c_a60c03a0-c7ae-4a9d-a408-92ae148403hu.jpg";
import BaseForm from "../../../../components/form";
import { useForm } from "react-hook-form";
import {
  GET,
  GET_ADDRESS_CUSTOMER,
  POST,
  UPDATE_CHANGE_ADDRESS,
  UPDATE_POST_ITR,
} from "../../../../services";
import { useMessage } from "../../../../hooks/useMessage";
import { IPropsModal } from "../../interfaces/modal";
import { DEFAULT_VALUE } from "../../constants/default-values";
import { FORM_EDIT } from "../../constants/forms";
import { useGetData } from "../../hook/useGetData";

const EditDataForm = (props: IPropsModal, ref) => {
  const { onCallbackEdit } = props;
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingInput, setLoadingInput] = useState(false);
  const [versionInfoVisible, setVersionInfoVisible] = useState(false);
  const { openMessage } = useMessage();
  const [optionAddress, setOptionAddress] = useState([]);
  const {
    useGetMachineImages,
    stateMachineImages,
    setStateMachineImages,
    useGetItemCodeMachine,
    optionMachines,
  } = useGetData();
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: DEFAULT_VALUE,
  });

  useImperativeHandle(ref, () => ({
    async openModal(e) {
      try {
        const [res, , machines] = await Promise.all([
          GET(GET_ADDRESS_CUSTOMER(e.customerCode)),
          useGetMachineImages(e.maintainId),
          useGetItemCodeMachine(),
        ]);
        const { address } = res.result;
        for (const key in e) {
          const element = e[key];
          if (key in DEFAULT_VALUE) {
            if (key === "postalAddressId" && element) {
              setValue("address", element);
            }
            setValue(key as keyof typeof DEFAULT_VALUE, element);
          }
        }
        // version ที่ได้ตอนกดเคลม (header) เป็นหลัก, fallback ค่าที่ save ไว้ (dmc)
        const claimVersion = e.claimVersionMachine || e.versionMachine;
        if (claimVersion) {
          setValue("versionMachine", claimVersion);
          // default itemCode = active itemCode ตัวแรกที่ version ตรง (เมื่อยังไม่เคยเลือก)
          // claim version อาจเป็น "version 3" / "3" ส่วน table เป็น int 3 → เทียบเฉพาะตัวเลข
          const claimNum = `${claimVersion}`.match(/\d+/)?.[0] ?? "";
          if (!e.itemCode && claimNum) {
            const match = (machines || []).find(
              (m) => `${m.versionMachine}`.match(/\d+/)?.[0] === claimNum
            );
            if (match) setValue("itemCode", match.itemCode);
          }
        }
        setOptionAddress(address);
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  useEffect(() => {
    if (!visible) {
      reset();
      setStateMachineImages([]);
    }
  }, [visible]);

  const onConfirm = async () => {
    try {
      setLoading(true);
      const {
        maintainChangeId,
        address: axAddressId,
        deviceId,
        customerCode,
        maintainId,
        itemCode,
        versionMachine,
      } = getValues();
      const findIndex = optionAddress.findIndex(
        (e) => e.addressId === axAddressId
      );
      if (findIndex === -1) {
        return;
      }
      const { addressName } = optionAddress[findIndex];
      const res = await POST(UPDATE_CHANGE_ADDRESS, {
        deviceId,
        maintainChangeId,
        axAddressId,
        axAddressName: addressName,
        customerCode,
        maintainId,
        itemCode,
        versionMachine,
      });
      if (!res.success) {
        return;
      }
      const r = await POST(UPDATE_POST_ITR, { maintainChangeId, maintainId });
      const { result } = r;
      setLoading(false);
      openMessage("success", res.message);
      setValue("postalAddressName", addressName);
      setValue("postalAddressId", axAddressId);
      onCallbackEdit && onCallbackEdit(getValues(), result);
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", error.message);
    }
  };

  async function changeCustomer(e, item) {
    try {
      if (item.ref === "itemCode") {
        // version เครื่องตัด ผูกกับ claim (set ตอนเปิด modal) — ไม่เปลี่ยนตาม itemCode ที่เลือก
        return;
      }
      const valueCustomerCode = e.target.value;
      if (item.ref === "customerCode") {
        setLoadingInput(true);
        setValue("address", []);
        if (valueCustomerCode.length === 15) {
          const res = await GET(GET_ADDRESS_CUSTOMER(valueCustomerCode));
          const { address } = res.result;
          setOptionAddress(address);
          setLoadingInput(false);
        } else {
          setOptionAddress([]);
          setLoadingInput(false);
        }
      }
    } catch (error) {}
  }

  return (
    <>
    <Modal
      width={700}
      title="แก้ไขข้อมูลเคลม"
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      centered
      onOk={handleSubmit(onConfirm)}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
    >
      {
        (
          <BaseForm
            control={control}
            forms={FORM_EDIT({ optionAddress, optionMachines, loadingInput, onClickVersionInfo: () => setVersionInfoVisible(true) })}
            setValue={setValue}
            getValues={getValues}
            onChange={(e, item) => changeCustomer(e, item)}
          />
        ) as React.ReactNode
      }
      {stateMachineImages.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>รูปภาพเครื่องตัด</div>
          <Image.PreviewGroup>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {stateMachineImages.map((img, idx) => (
                <Image
                  key={`${img.MaintainID}-${idx}`}
                  width={80}
                  height={80}
                  src={img.Url}
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                />
              ))}
            </div>
          </Image.PreviewGroup>
        </div>
      )}
    </Modal>
    <Modal
      title="ความแตกต่างของเครื่องตัดฟิล์มแต่ละเวอร์ชัน"
      visible={versionInfoVisible}
      onCancel={() => setVersionInfoVisible(false)}
      footer={null}
      centered
      width={600}
    >
      <img
        src={machineVersionGuide}
        alt="machine-version-guide"
        style={{ width: "100%", borderRadius: 4 }}
      />
    </Modal>
    </>
  );
};

export const EditData = forwardRef<any, IPropsModal>(EditDataForm);
